import { CitationSource, SearchResultItem } from "@cohesive/ui-components";

const MARKDOWN_LINK_RE = /\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g;

function hostnameOf(url: string): string | null {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return null;
  }
}

/**
 * Derive citation pills for the final assistant answer from the markdown
 * links it contains: numbered by first appearance, deduped by hostname.
 */
export function deriveCitationsFromMarkdown(content: string): CitationSource[] {
  const sources: CitationSource[] = [];
  const seen = new Set<string>();
  for (const match of content.matchAll(MARKDOWN_LINK_RE)) {
    const [, title, url] = match;
    const domain = hostnameOf(url);
    if (!domain || seen.has(domain)) continue;
    seen.add(domain);
    sources.push({ domain, url, title: title || undefined });
  }
  return sources;
}

/**
 * Fallback for web-search results stored before the backend captured URL
 * citations: extract result rows from the markdown links in the flat result
 * string (deduped by URL; link text becomes the title).
 */
export function deriveSearchResultsFromMarkdown(
  content: string,
): SearchResultItem[] {
  const results: SearchResultItem[] = [];
  const seen = new Set<string>();
  for (const match of content.matchAll(MARKDOWN_LINK_RE)) {
    const [, title, url] = match;
    const domain = hostnameOf(url);
    if (!domain || seen.has(url)) continue;
    seen.add(url);
    results.push({ title: title || domain, domain, url });
  }
  return results;
}
